export const FLIGHT_DIRECTION = {
  Departing: 'Departing',
  Returning: 'Returning',
} as const;

export type FlightDirection = keyof typeof FLIGHT_DIRECTION;
